import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { GetExternalUrlsFromDomain } from 'polaris-adventures-js'

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(
    {
      backend: {
        loadPath: `${
          GetExternalUrlsFromDomain('WaiverWeb', window.location.origin, process.env.REACT_APP_LOCAL_DEV_BACKEND).BackendApi
        }/member/customer-waiver/locale/{{lng}}.json`
      },
      lng: 'en',
      fallbackLng: 'en',
      preload: ['en'],
      debug: true
    },
    (err) => {
      if (err) console.log('i18n error', err)
    }
  )

export function prepareLanguage() {
  const langs = ['de', 'en', 'es', 'fr', 'fr_CA', 'it', 'pl']
  const isLanguageSupported = (lng = i18n.language) => langs.includes(lng)

  if (!isLanguageSupported() && i18n.language.length > 2) {
    const lng2 = i18n.language.substr(0, 2).toLowerCase()
    if (isLanguageSupported(lng2)) {
      i18n.changeLanguage(lng2)
    } else {
      i18n.changeLanguage('en-US')
    }
  } else if (!isLanguageSupported()) {
    i18n.changeLanguage('en-US')
  }
}

export default i18n
